/**
 * Terms & Conditions Interfaces
 * Type definitions for Terms & Conditions management
 */

/**
 * Terms & Conditions Item
 */
export interface TermsConditionItem {
  program_name: string;
  terms_conditions: string;
  program_id: number;
}

/**
 * API Response for Terms & Conditions
 */
export interface TermsConditionApiResponse {
  data: TermsConditionItem;
}

/**
 * Terms & Conditions Update Payload
 */
export interface TermsConditionUpdatePayload {
  terms_conditions: string;
  program_id: number;
}

/**
 * API Response for Update Terms & Conditions
 */
export interface TermsConditionUpdateApiResponse {
  body: {
    data: {
      message: string;
    };
  };
}
